import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@mui/material";

import { buttonStyle } from "../../../styles/navBarStyle";

function LoginButton() {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  return isAuthenticated ? null : (
    <Button
      sx={{
        ...buttonStyle,
        marginRight: 0,
        fontSize: {
          xs: "0.75rem",
          sm: "0.875rem",
          md: "1rem",
        },
        padding: {
          xs: "4px 8px",
          sm: "6px 12px",
          md: "8px 16px",
        },
        minWidth: {
          xs: "60px",
          sm: "70px",
          md: "80px",
        },
      }}
      onClick={async () =>
        await loginWithRedirect({
          appState: {
            returnTo: window.location.pathname + window.location.search,
          },
        })
      }
    >
      Log in
    </Button>
  );
}

export default LoginButton;
